"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlessingOfAlaresaAbilityHandler = exports.BlessingOfAlaresaActorAbilityFactory = exports.BlessingOfAlaresaAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const MaxAttributeIncrease_1 = require("../../core/effects/core/MaxAttributeIncrease");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class BlessingOfAlaresaAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BlessingOfAlaresa;
        this.__typeName = "BlessingOfAlaresa";
    }
}
exports.BlessingOfAlaresaAbilityArgs = BlessingOfAlaresaAbilityArgs;
let BlessingOfAlaresaActorAbilityFactory = class BlessingOfAlaresaActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BlessingOfAlaresa", "AllAllies", 4);
    }
};
BlessingOfAlaresaActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BlessingOfAlaresa")
], BlessingOfAlaresaActorAbilityFactory);
exports.BlessingOfAlaresaActorAbilityFactory = BlessingOfAlaresaActorAbilityFactory;
let BlessingOfAlaresaAbilityHandler = class BlessingOfAlaresaAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(allyId => {
                    container.applyBuff({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId: allyId,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new core_1.LinkedEffectsEffectArgs(Array.from(AttributeType_1.PRIMARY_ATTRIBUTES).map(attr => new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(attr, container.getPercentOfBaseAttributeScore(allyId, 10, attr))), false),
                        onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(allyId, "feet"), "DivineHealingWinds"))
                    });
                });
            }
        });
    }
};
BlessingOfAlaresaAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BlessingOfAlaresa)
], BlessingOfAlaresaAbilityHandler);
exports.BlessingOfAlaresaAbilityHandler = BlessingOfAlaresaAbilityHandler;
